import script from "./UpdateWords.vue?vue&type=script&lang=js"
export * from "./UpdateWords.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__